import { getGPUTier } from 'detect-gpu';
import type { QualityPreset, QualityTier } from '@/types';
import { getRenderer } from './renderer';

const QUALITY_PRESETS: Record<QualityTier, QualityPreset> = {
  low: {
    pixelRatio: 1,
    shadows: false,
    bloom: false,
    ssao: false,
  },
  medium: {
    pixelRatio: Math.min(window.devicePixelRatio, 1.5),
    shadows: true,
    bloom: true,
    ssao: false,
  },
  high: {
    pixelRatio: Math.min(window.devicePixelRatio, 2),
    shadows: true,
    bloom: true,
    ssao: true,
  },
};

let currentPreset: QualityPreset = QUALITY_PRESETS.medium;
let currentTier: QualityTier = 'medium';

export async function detectQuality(): Promise<QualityPreset> {
  try {
    const gpuTier = await getGPUTier();
    if (gpuTier.tier <= 1) {
      currentTier = 'low';
    } else if (gpuTier.tier === 2) {
      currentTier = 'medium';
    } else {
      currentTier = 'high';
    }
  } catch (err) {
    console.warn('[QualityScaler] GPU detection failed, defaulting to medium:', err);
    currentTier = 'medium';
  }

  currentPreset = QUALITY_PRESETS[currentTier];
  applyPreset(currentPreset);
  return currentPreset;
}

function applyPreset(preset: QualityPreset): void {
  const renderer = getRenderer();
  renderer.setPixelRatio(preset.pixelRatio);
  renderer.shadowMap.enabled = preset.shadows;
}

export function getQualityPreset(): QualityPreset {
  return currentPreset;
}

export function getQualityTier(): QualityTier {
  return currentTier;
}
